import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getReq, postReqWithResponse }  from "../middleware/AxiosApisCall";
import {
  StyledTableCell,
  HeaderTableCell,
  StyledTableRow,
} from "../Partials/TableStyle";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Paper,
  TablePagination,
} from "@mui/material";
import Loading from "../Loading";
import { SuccessAlert, ErrorAlert } from "../middleware/AlertMsg";

function DeviceMapping() {
  const path = "Machine";
  const navigate = useNavigate();
  const [load, setLoad] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [mappedMachineData, setMappedMachineData] = useState([]);
  const [vendorData, setVendorData] = useState(undefined);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [newMappedData, setNewMappedData] = useState([]);
  const [isSearchVisible, setSearchVisible] = useState(false);
  const [isVisibleArray, setIsVisibleArray] = useState([]);
  const [filteredVendors, setFilteredVendors] = useState([]);
  const suggestionsContainerRef = useRef(null);

  const columnHeadings = ["machine_id", "machine_name", "device_name"];

  const loadTableData = async () => {
    const respMachines = await getReq(path);
    const respMappings = await getReq("mappings");
    const respVendors = await getReq("snaxsmart/devices");

    setMappedMachineData(respMappings);
    setLoad(true);
    if (respVendors && respVendors.length) {
      setVendorData(respVendors);
    } else {
      setVendorData([]);
    }

    if (respMachines.data?.length) {
      const data = respMachines.data.map((item) => {
        const mapData = respMappings.filter(
          (mappedItem) => mappedItem.machine_id === item.machine_id
        );
        const device_name = respVendors.find(
          (vendor) => vendor.id === mapData[0]?.device_id
        )?.name;
        return {
          id: mapData[0]?._id,
          machine_id: item.machine_id,
          machine_name: item.machine_name,
          device_id: mapData[0]?.device_id,
          device_name: device_name,
        };
      });
      setTableData(data);
    } else {
      setTableData([]);
    }
  };

  useEffect(() => {
    loadTableData();
  }, []);

  const mappings = (id, machine_id, device_id, device_name) => {
    if (
      newMappedData.findIndex((item) => {
        return item.vendor_id === device_id;
      }) > -1
    ) {
      ErrorAlert({ title: "Mapping", message: "Machine Already Mapped" });
      return;
    }
    const prevData = newMappedData.filter((item) => {
      return item.machine_id !== machine_id;
    });
    const data = { id: id, machine_id: machine_id, device_id: device_id, device_name:device_name };
    setNewMappedData([...prevData, data]);
  };

  const saveMappings = async (item) => {
    const newMappings = newMappedData.filter(
      (machine) => machine.id === undefined
    );

    const updatedMappings = newMappedData.filter((item1) =>
      mappedMachineData.some(
        (item2) => item2["machine_id"] === item1["machine_id"]
      )
    );

    const deletedMappings = tableData.filter(
      (machine) => machine.id !== undefined && machine.device_id === null
    );

    if(newMappings.length === 0 && updatedMappings.length === 0 && deletedMappings.length === 0){
      return;
    }

    const data = {
      deleted: deletedMappings,
      updated: updatedMappings,
      inserted: newMappings,
    };
    const respPost = await postReqWithResponse("mappings/manage", data);
    if (respPost.status === 200) {
      SuccessAlert({
        title: "Mapping updates",
        message: "Device Mapped successfully",
      });
    } else {
      ErrorAlert({ title: "Mapping updates", message: respPost.message });
    }
  };

  const handleSearch = (e, id, index) => {
    setSearchVisible(true);
    const value = e.target.value;

    const updatedVisibleArray = isVisibleArray.map((visible, i) =>
      i === index ? true : false
    );
    setIsVisibleArray(updatedVisibleArray);
    const filtered = vendorData.filter(
      (vendor) =>
        vendor.name.toLowerCase().includes(value.toLowerCase()) &&
        tableData.findIndex((item) => {
          return item.device_id === vendor.id;
        }) === -1
    );
    setFilteredVendors((prev) => {
      return [prev, ...filtered];
    });
  };

  const updateMapping = (id, machine_id, device_id, device_name) => {
    setSearchVisible(false);
    const filter = tableData.findIndex((item) => {
      return item.device_id === device_id;
    });
    if (filter > -1) {
      ErrorAlert({ title: "Device Mapping", message: "Device Already Mapped" });
      return;
    }
    const data = tableData.map((item) => {
      if (item.machine_id === machine_id) {
        mappings(id, machine_id, device_id, device_name);
        return {
          ...item,
          device_id: device_id,
          device_name: device_name,
        };
      } else {
        return item;
      }
    });

    setTableData(data);
    setIsVisibleArray(new Array(data.length).fill(false));
  };

  const deleteMapping = (id, machine_id) => {
    const data = tableData.map((item) => {
      if (item.machine_id === machine_id) {
        return {
          ...item,
          device_id: null,
          device_name: null,
        };
      } else {
        return item;
      }
    });
    setTableData(data);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const devicesListStyle = {
    width: "100%",
    minWidth: "300px",
    margin: "auto",
    maxHeight: "200px",
    overflowY: "auto",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
    padding: "3px 3px",
    boxShadow: "rgba(0, 0, 0, 0.4) 0px 30px 90px",
    position: "absolute",
    top: "100%",
    right: "1%",
    zIndex: "999999",
  };

  const deleteBtnStyle = {
    backgroundColor: "red",
    color: "white",
    padding: "6px",
    borderRadius: "5px",
    borderStyle: "none",
    cursor: "pointer",
  };

  return (
    <>
      <div className="add-user-container">
        <div className="headingdiv">
          <span className="componet-title">VEND VIITOR Device Mapping</span>
          <div className="headingdiv">
            <div>
              <button
                onClick={() => {
                  navigate(-1);
                }}
              >
                Back
              </button>
            </div>
            <div style={{ marginLeft: "10px" }}>
              <button
                onClick={() => {
                  saveMappings();
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>

        {load ? (
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <StyledTableRow>
                  <HeaderTableCell>Sl.No</HeaderTableCell>
                  <HeaderTableCell>Machine ID</HeaderTableCell>
                  <HeaderTableCell>Machine Name</HeaderTableCell>
                  <HeaderTableCell>Device Name</HeaderTableCell>
                  {/* {columnHeadings.map((heading, index) => (
                    <HeaderTableCell key={index}>
                      {heading.charAt(0).toUpperCase() + heading.slice(1)}
                    </HeaderTableCell>
                  ))} */}
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {tableData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index) => (
                    <StyledTableRow
                      key={item.machine_id}
                      sx={{
                        backgroundColor: index % 2 === 0 ? "#f5f5f5" : "white",
                      }}
                    >
                      <StyledTableCell sx={{ textAlign: "center" }}>
                        {page * rowsPerPage + index + 1}
                      </StyledTableCell>
                      {columnHeadings.map((heading, i) =>
                        heading.toLowerCase() !== "device_name" ? (
                          <StyledTableCell key={i}>
                            {item[heading]}
                          </StyledTableCell>
                        ) : (
                          vendorData && (
                            <StyledTableCell>
                              <div
                                style={{
                                  display: "flex-row",
                                  flexDirection: "row",
                                  position: "relative",
                                }}
                              >
                                <input
                                  key={item.device_id}
                                  style={{
                                    padding: "7px",
                                    frontWeight: "bold",
                                    fontSize: "16px",
                                  }}
                                  type="text"
                                  value={
                                    item.device_name 
                                  }
                                  onClick={(e) => {
                                    setSearchVisible(!isSearchVisible);
                                    setIsVisibleArray(
                                      new Array(vendorData.length).fill(false)
                                    );
                                  }}
                                  onChange={(e) =>
                                    handleSearch(e, item.device_id, index)
                                  }
                                />
                                {item.device_id && (
                                  <button
                                    style={deleteBtnStyle}
                                    onClick={() =>
                                      deleteMapping(item.id, item.machine_id)
                                    }
                                  >
                                    X
                                  </button>
                                )}
                                {isVisibleArray[index] && isSearchVisible && (
                                  <div
                                    key={index}
                                    ref={suggestionsContainerRef}
                                    style={devicesListStyle}
                                  >
                                    {filteredVendors.map((vendor, index) => (
                                      <div
                                        key={vendor.id}
                                        onClick={() =>
                                          updateMapping(
                                            item.id,
                                            item.machine_id,
                                            vendor.id,
                                            vendor.name
                                          )
                                        }
                                        style={{
                                          cursor: "pointer",
                                          padding: "3px 10px 0px",
                                          boxShadow:
                                            "rgba(0, 0, 0, 0.45) 0px 25px 20px -20px",
                                          borderBottom: "1px solid gray",
                                        }}
                                      >
                                        {vendor.name}{" "}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </StyledTableCell>
                          )
                        )
                      )}
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50, 100]}
              component="div"
              count={tableData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        ) : (
          <Loading />
        )}
      </div>
    </>
  );
}
export default DeviceMapping;
